/**
 * Generic interface representing a paginated response from the backend using offset pagination.
 */
export interface PaginatedResponse<T> {
	totalEntities: number;
	range: number;
	offset: number;
	entities: T[];
}

export const emptyPaginatedResponse = <T>(): PaginatedResponse<T> => ({
	totalEntities: 0,
	range: 0,
	offset: 0,
	entities: [],
});

export interface ApiPaginatedResponse<T> {
	totalItems: number;
	range: number;
	offset: number;
	results: T[];
}
